<template>
  <!--
    No declarative markup: the role-change menu is an Action Sheet created
    imperatively via openRoleChangeActionsPopover(). It is automatically
    converted to a Popover anchored to the trigger element on large screens.
  -->
</template>

<script setup>
import { onBeforeUnmount } from 'vue'
import { f7 } from 'framework7-vue'
import { ASSIGNABLE_ROLES, roleMeta } from '../../constants/member-roles.js'
import i18n from '../../js/i18n.js'

const { t } = i18n.global

const REMOVE_COLOR = '#E53935'
const CLOSE_COLOR = '#8E8E93'

const emit = defineEmits(['change-role', 'remove', 'close'])

let actions = null

function icon(name, color) {
  return `<i class="f7-icons" style="color:${color}">${name}</i>`
}

function buildButtons(member) {
  const roleButtons = ASSIGNABLE_ROLES.map((role) => {
    const meta = roleMeta(role)
    return {
      icon: icon(meta.icon, meta.color),
      text:
        `<span style="color:${meta.color}">${t(meta.label)}</span>` +
        `<br><small style="color:var(--f7-on-surface-variant, #8e8e93)">${t(meta.desc)}</small>`,
      strong: role === member?.role,
      onClick: () => emit('change-role', role),
    }
  })
  return [
    [{ text: member?.name ?? '', label: true }, ...roleButtons],
    [{ icon: icon('trash', REMOVE_COLOR), text: `<span style="color:${REMOVE_COLOR}">${t('group.remove')}</span>`, onClick: () => emit('remove') }],
    [{ icon: icon('xmark', CLOSE_COLOR), text: t('common.cancel'), strong: true, onClick: () => emit('close') }],
  ]
}

function openRoleChangeActionsPopover(member, targetEl) {
  actions?.destroy()
  actions = f7.actions.create({
    convertToPopover: true,
    closeByOutsideClick: true,
    closeOnEscape: true,
    targetEl,
    buttons: buildButtons(member),
    on: { closed: () => emit('close') },
  })
  actions.open()
}

onBeforeUnmount(() => {
  actions?.destroy()
  actions = null
})

defineExpose({ openRoleChangeActionsPopover })
</script>
